import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 7L2 22h15z"
})), 'NetworkCell');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NetworkCell.js
// module id = 5011
// module chunks = 2